import React, { useState } from "react";
import { AiOutlinePhone } from "react-icons/ai";
import { IoIosArrowDown } from "react-icons/io";
import { useRouter } from "next/router";
import { EMAIL_SUBSCIBE } from "@/services/home/subscibe";

import Spinner from "../../icons/Spinner";
import { event_newsletter_subscribed } from "@/utils/gtm";
import Link from "next/link";
import NextImage from "@/components/NextImage";
import { validateImgSrc } from "@/utils/global";

const CompanySocialInformation = ({ t, active, onActiveAccordion, data }) => {
  const [isValid, setIsValid] = useState(true);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [email, setEmail] = useState("");
  const { locale } = useRouter();

  const handleSubscibe = (e) => {
    e.preventDefault();
    setLoading(true);
    if (!isValid && !email) {
      return undefined;
    }
    EMAIL_SUBSCIBE(email)
      .then(({ data }) => {
        const { error, message } = data?.data[0] || {};
        setIsValid(!error);
        setMsg(message);
        setTimeout(() => {
          setIsValid(true);
          setMsg("");
          setEmail("");
          event_newsletter_subscribed(email);
        }, 5000);
      })
      .finally(() => setLoading(false));
  };

  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setIsValid(emailRegex.test(value));
  };

  const handleEmailChange = (event) => {
    const { value } = event.target;
    setEmail(value);
    validateEmail(value);
    setMsg(
      isValid
        ? ""
        : locale == "ar"
        ? "بريد إلكتروني غير صحيح"
        : "invalid email address"
    );
  };

  return (
    <div className="col-span-3 max-[1200px]:col-span-4 max-[700px]:col-span-8 max-[700px]:bg-zinc-600 max-[700px]:px-2 max-[700px]:rounded-md">
      <div
        id="newsletter-accordion"
        onClick={() => onActiveAccordion(active === "news" ? null : "news")}
        className="max-[700px]:flex max-[700px]:items-center max-[700px]:justify-between"
      >
        <h2 className="mb-4 text-xl font-bold max-[700px]:my-2">
          {t("NewsLetter")}
        </h2>
        <IoIosArrowDown
          size="24px"
          className={`hidden max-[700px]:block ${
            active === "news" ? "rotate-180" : "rotate-0"
          }`}
        />
      </div>
      <p className="text-[15px] my-4 max-[700px]:hidden max-w-[80%] leading-6">
        {t("NewsLetterDescription")}
      </p>
      <div
        className={`flex items-center my-7 max-[700px]:my-4 ${
          active !== "news" && "max-[700px]:hidden"
        }`}
      >
        <AiOutlinePhone size="20px" />
        <span className="mx-2 mb-1">
          {t("Contact")} <bdi> {data?.about?.telphone}</bdi>{" "}
        </span>
      </div>
      <form
        onSubmit={handleSubscibe}
        className={`my-4 flex items-center max-w-[80%] ${
          active !== "news" && "max-[700px]:hidden"
        }`}
      >
        <input
          id="newsletter"
          defaultValue={email}
          type="email"
          onChange={handleEmailChange}
          className={`flex-1 outline-none border-none p-3 max-[360px]:p-[7px] bg-white text-zinc-700 ${
            locale === "en"
              ? "rounded-tl-md rounded-bl-md"
              : "rounded-tr-md rounded-br-md"
          }`}
          placeholder={t("SuggestEmailAddress")}
        />
        <button
          disabled={loading || !email}
          className={`py-3 px-5 max-[360px]:p-[7px] bg-red border-red hover:bg-lightred disabled:bg-lightred duration-500 transition-colors text-white font-semibold ${
            locale === "en"
              ? "rounded-tr-md rounded-br-md"
              : "rounded-tl-md rounded-bl-md"
          }`}
        >
          {loading ? (
            <span className="flex items-center justify-center gap-2">
              <Spinner width={24} />
              <span>{t("Subscribing")}</span>
            </span>
          ) : (
            t("Subscribe")
          )}
        </button>
      </form>
      <div
        className={`p-2  ${
          isValid ? "text-green-500 " : "text-red mb-4"
        } text-sm -mt-3 `}
      >
        {msg || ""}
      </div>
      <div
        className={`max-[700px]:mb-3 flex items-center gap-3 ${
          active !== "news" && "max-[700px]:hidden"
        }`}
      >
        {data?.["social-links"]?.map((social) => (
          <Link
            href={
              social?.url?.startsWith("https://")
                ? social?.url
                : `https://${social?.url}`
            }
            target="_blank"
            key={social?.url}
          >
            <NextImage
              src={validateImgSrc(social?.["icon-img"])}
              className="object-contain size-6 hover:translate-y-[-2px] hover:opacity-75 transition-all"
              width={24}
              height={24}
              alt={social?.url}
            />
          </Link>
        ))}
      </div>
    </div>
  );
};

export default CompanySocialInformation;
